import { getConfig } from "../../client/config";
// NOTE: this message text must stay BYTE-IDENTICAL to what the wallet-auth
// verifier reconstructs — any drift breaks every SIWS login.
export async function genSolanaMessage(address, nonce, appIdOverride) {
    var _a, _b;
    /*  Domain / origin aren't available server-side – fall back to envs
        or simple placeholders.  */
    const domain = (typeof process !== 'undefined' && ((_a = process.env) === null || _a === void 0 ? void 0 : _a.SESSION_DOMAIN)) || "server";
    const origin = (typeof process !== 'undefined' && ((_b = process.env) === null || _b === void 0 ? void 0 : _b.SESSION_ORIGIN)) || "server";
    // SECURITY (audit-4 CRITICAL-1): bind the signed prompt to the target app.
    // A server wallet client passes its snapshotted appId (appIdOverride) so the
    // signed "App ID" stays bound to the app the wallet client was created against
    // even after a later global init() (CTA-05); the default path reads the SAME
    // global config that genAuthNonce + /session use, so the signed "App ID" is
    // guaranteed to equal the app the session is minted for; the server verifier
    // rejects any mismatch.
    const appId = appIdOverride !== null && appIdOverride !== void 0 ? appIdOverride : (await getConfig()).appId;
    const statement = "Sign this message to authenticate with our application.";
    const currentDate = new Date();
    const issuedAt = currentDate.toISOString();
    const expirationTime = new Date(currentDate.getTime() + 5 * 60 * 1000).toISOString();
    return `${statement}\n\n` +
        `Wallet address:\n${address}\n\n` +
        `App ID: ${appId}\n` +
        `Domain: ${domain}\n` +
        `Origin: ${origin}\n` +
        `Nonce: ${nonce}\n` +
        `Issued At: ${issuedAt}\n` +
        `Expiration Time: ${expirationTime}`;
}
